import { useMemo } from 'react';
import axios, { type RawAxiosRequestHeaders } from 'axios';

import { getPartitionNumber } from '../../services/partition-service';

const CUI_BASE = '/connections-ui';

export const useCuiApiConfig = () => {
  return useMemo(
    () => ({
      baseUrl: CUI_BASE,
      partitionId: getPartitionNumber(),
      get: (path: string) => axios.get(path, { baseURL: CUI_BASE }).then((r) => r.data),
      post: (path: string, data: unknown, addlHeaders?: RawAxiosRequestHeaders) =>
        axios.post(path, data, { baseURL: CUI_BASE, headers: addlHeaders }).then((r) => r.data),
      put: (path: string, data: unknown) => axios.put(path, data, { baseURL: CUI_BASE }).then((r) => r.data),
      deleteMethod: (path: string, data?: unknown) => axios.delete(path, { baseURL: CUI_BASE, data }).then((r) => r.data),
    }),
    [],
  );
};
